const CLS_PREFIX = 'tui-grid-'
function cls(...names) {
  const result = []

  for (const name of names) {
    let className
    if (Array.isArray(name)) {
      className = name[0] ? name[1] : null
    } else {
      className = name
    }

    if (className) {
      result.push(`${CLS_PREFIX}${className}`)
    }
  }

  return result.join(' ')
}
export default class CustomRenderer {
  setAttrsOrStyles(type, targets) {
    Object.keys(targets).forEach((name) => {
      const value =
      typeof targets[name] === 'function'
          ? targets[name](this.props)
          : targets[name]
      if (type === 'attrs') {
        this.el.setAttribute(name, value)
      } else {
        this.el.style[name] = value
      }
    })
  }
  setClassNames(classNames) {
    let classString = ' '
    if (classNames && classNames.length > 0) {
      classNames.forEach((className) => {
        const value =
        typeof className === 'function' ? className(this.props) : className
        classString += ` ${value}`
      })
    }
    this.el.className = cls('cell-content') + classString
  }
  constructor(props) {
    // console.purple('startCustomRender')
    const el = document.createElement('div')
    const {ellipsis, whiteSpace, renderer} = props.columnInfo
    if (ellipsis) {
      el.style.textOverflow = 'ellipsis'
    }
    if (whiteSpace) {
      el.style.whiteSpace = whiteSpace
    }
    
    this.props = props
    this.el = el

    if (renderer) {
      const {attributes, styles, classNames} = renderer

      if (attributes) {
        this.setAttrsOrStyles('attrs', attributes)
      }
      if (styles) {
        this.setAttrsOrStyles('styles', styles)
      }
      if (classNames) {
        this.setClassNames(classNames)
      } else {
        el.className = cls('cell-content')
      }
    } else {
      el.className = cls('cell-content')
    }

    this.render(props)
    // console.purple('finishCustomRender')
  }

  getElement() {
    return this.el
  }

  render(props) {
    this.props = props
    const {renderer} = props.columnInfo
    if (renderer) {
      const {attributes, styles, classNames} = renderer
      if (attributes) {
        this.setAttrsOrStyles('attrs', attributes)
      }
      if (styles) {
        this.setAttrsOrStyles('styles', styles)
      }
      if (classNames) {
        this.setClassNames(classNames)
      }
    }
    this.el.innerHTML = `${props.formattedValue}`
  }
}
